import React from 'react';
import PropTypes from 'prop-types';

import Percentage from './percentage';

class Percentages extends React.Component {
    static propTypes = {
        percentage_options: PropTypes.arrayOf(PropTypes.number).isRequired,
        getTipPercentage: PropTypes.func.isRequired,
        exceeds_largest_percentage_option: PropTypes.bool.isRequired,
        value: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    onSelectHandler = percentage => {
        const { onChange } = this.props;
        onChange(percentage);
    };

    render() {
        const {
            percentage_options,
            exceeds_largest_percentage_option,
            getTipPercentage,
            value,
        } = this.props;

        return (
            <div className="m2g-order-tip-modal-percentages">
                {percentage_options.map(percentage => {
                    const is_last_and_exceeds =
                        percentage ===
                            percentage_options[percentage_options.length - 1] &&
                        exceeds_largest_percentage_option;
                    const selected =
                        !!value &&
                        (getTipPercentage(percentage) === value ||
                            is_last_and_exceeds);
                    return (
                        <Percentage
                            key={percentage}
                            selected={selected}
                            onSelect={this.onSelectHandler}
                            value={percentage}
                            exceeds={is_last_and_exceeds}
                        />
                    );
                })}
            </div>
        );
    }
}

export default Percentages;
